module.exports = __webpack_public_path__ + "static/img/15.8b91fad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/15.jpg
// module id = jRX5
// module chunks = 18